import { LandingPage } from 'almanac-ui/icons/blaze/32'
import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { avoid } from './shared/avoid'
import { productFeatures } from './shared/productFeatures'
import { productName } from './shared/productName'
import { seoWords } from './shared/seoWords'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.LandingPage,
  icon: LandingPage,
  steps: ['Context', 'Generate Landing Page'],
  title: TextChannels[ChannelType.LandingPage].name,
  submitLabel: 'Generate Landing Page',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183788/Home%20Card%20Previews/eoxinaucdhepivlzf8ok.png',
}

const fields = {
  topic: topic.meta({ label: 'What is this landing page about?', generationType: meta.type }),
  product_name: productName.required(),
  product_features: productFeatures.required(),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your landing page far more engaging and attention grabbing',
  }),
  seo_words: seoWords,
  avoid: avoid.meta({ collapsible: true }),
}

export const LandingPageSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const LandingPageMultiStepSchema: MultiStepSchema<ChannelType.LandingPage> = {
  steps: [
    LandingPageSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.LandingPage,
    channel: ChannelType.LandingPage,
  },
}
